<template>
  <div class="panel-body">
      <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <vue-form-generator :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
    {{this.msg_conferma}}
    <h4>Storico lotti</h4>
    <div id="table" v-if="products_record" class="records-table">
    <b-table striped responsive id="records"
    :fields="[{key:'code',label:'Codice lotto'},
    {key:'notarization_status', label:'Stato Notarizzazione'},
    {key:'created_at', label:'Data di registrazione'},
    {key:'button', label:'Riferimento Contratto'}]" 
    :items="products_record"
    :per-page="perPage"
    :current-page="currentPage">
        <template slot="button" slot-scope="products_record" v-if="products_record.item.contract != null || products_record.item.transaction != null">
            <a :href="products_record.item.contract != null ? `https://polygonscan.com/address/${products_record.item.contract.address}` : `https://polygonscan.com/tx/${products_record.item.transaction.txhash}`" target="_blank" class="ether-link">{{ products_record.item.contract != null ? products_record.item.contract.address : products_record.item.transaction.txhash }}</a>
        </template>
    </b-table>
    
        <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="records"
      align="center"
    ></b-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// @ is an alias to /src
export default {
  name: 'notarizzazione',
  components: {
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      notarizeUrl: process.env.VUE_APP_NOTARIZE_API,
      config: {headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }},
      config_notarize: {headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }},
      loading: false,
      msg_conferma: '',
      currentPage: 1,
      perPage: 10,
      products_record: '',
      model: {
        batch_code: [],
        confirm: ''
        },
      schema: {
        fields: [
          {
            type: 'select',
            inputType: 'number',
            label: 'Codice del lotto',
            model: 'batch_code',
            values: []
          },
          {
            type: 'select',
            label: 'Conferma notarizzazione',
            model: 'confirm',
            values: ["Si", "No"]
          },
          {
            type: 'submit',
            buttonText: 'Invia',
            validateBeforeSubmit: true,
            onSubmit: this.saveForm
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  computed: {
    rows: function () {
      if (this.products_record) {
      return this.products_record.length
      }
      else {
        return 0
      }
    }
  },
  mounted () {
      this.getProducts()
  },
  methods: {
      saveForm: function () {
    if (this.model.confirm === "Si") {
      this.loading = true
      var notarizing = ''
    for (var p of this.products_record) {
      if (p.code === this.model.batch_code) {
       notarizing = p
      }
    }
    if (!notarizing.batchraws.length || !notarizing.packaging_date || !notarizing.delivery) {
      this.msg_conferma = "Questo lotto ha delle informazioni mancanti, hai registrato le informazioni relative ai conferimenti, alla trasformazione, al confezionamento ed alla distribuzione?"
      this.loading = false
    }
    else {
    axios.get(this.notarizeUrl + 'notarize/'+ this.model.batch_code, this.config_notarize).then(() => {
      // eslint-disable-next-line
      //  console.log(response.data)
      this.msg_conferma = "Notarizzazione avviata con successo. Una volta completata vedrai il lotto tra quelli nella tabella sottostante"
      this.loading = false
    }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      this.msg_conferma = 'Si è verificato un errore, riprova'
      }).finally(() => {
      this.getProducts()
      this.loading = false
  }); 
    }
    }
    else {
      this.msg_conferma = "Devi confermare di voler notarizzare per continuare"
      this.loading = false
    }
    },
    getProducts: function () {
    axios.get(this.apiUrl + 'products?_sort=created_at:DESC', this.config)
      .then(response => {
      this.products_record = response.data
      for (var p of this.products_record) {
        var date = new Date(p.created_at)
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var dt = date.getDate();
        if (dt < 10) {
          dt = '0' + dt;
        }
        if (month < 10) {
          month = '0' + month;
        }
        p.created_at = dt + '/' + month + '/' + year
      }
      let batch_values = []
      for (let r of response.data) {
      batch_values.push(
        {"name": r.code,
        "id" : r.code
        }
      )
      }
      // eslint-disable-next-line
      // console.log("Getting data:", batch_values)
      this.$store.commit('BATCHLIST_FETCH', batch_values)
      this.schema.fields[0].values = batch_values
      })
    }
}
}
</script>

<style>
.page-item.active .page-link {
  background-color: #520008!important;
  border-color: #666!important;
  color: #fff!important;
}
.page-link {
  color: #520008!important;
}
.ether-link {
  color: #520008!important;
}
.records-table {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  font-size:0.85rem;
}
</style>
